import { Component } from '@angular/core';
import {
  RestorationMetricMapWidgetComponent,
} from '../restoration-metric-map-widget/restoration-metric-map-widget.component';

@Component({
  selector: 'tgrid-restoration-metric-auc-widget',
  imports: [
    RestorationMetricMapWidgetComponent,
  ],
  templateUrl: './restoration-metric-auc-widget.component.html',
  styleUrl: './restoration-metric-auc-widget.component.scss',
})
export class RestorationMetricAucWidgetComponent {

}
